export default __webpack_public_path__ + "static/media/hangouts_chat.220a7ca3.svg";